import React, { useState } from 'react';
import { Box, CircularProgress, IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import SyncIcon from '@mui/icons-material/Sync';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Page } from '@tassomutuo-backoffice/types';

import configEnv from '../../../../config/config';

interface IProps {
  page: Page;
  onDeleteClick: () => void;
  onSyncClick: () => Promise<void>;
}

const PageTableRenderCellAction = ({
  page,
  onDeleteClick,
  onSyncClick,
}: IProps) => {
  const [loadingSync, setLoadingSync] = useState(false);

  const onSyncHandler = async () => {
    try {
      setLoadingSync(true);
      await onSyncClick();
    } finally {
      setLoadingSync(false);
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
      }}
    >
      {configEnv.isStage && (
        <Tooltip title="Sincronizza con CMS">
          <IconButton disabled={loadingSync} onClick={onSyncHandler}>
            {loadingSync ? <CircularProgress size={20} /> : <SyncIcon />}
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title="Visualizza su Tassomutuo">
        <IconButton
          disabled={loadingSync}
          component="a"
          href={`${configEnv.tassomutuoBaseUrl}/${page.path}`}
          target="_blank"
        >
          <OpenInNewIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Elimina pagina">
        <IconButton disabled={loadingSync} onClick={onDeleteClick}>
          <DeleteOutlineIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default PageTableRenderCellAction;
